import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import WarningAlertIcon from '../../../assets/warning-alert-circle.svg';
import {INGESTION_STATUSES} from '../../../constants';
import {DARK_TEXT_COLOR, ERROR_BG, GREEN_BUTTON} from '../../../theme';
import {ProcessingContainer} from '../ProcessingContainer';

const styles = {
  errorContainer: {
    alignItems: 'center',
    backgroundColor: ERROR_BG,
    borderRadius: '50%',
    display: 'flex',
    height: '6.5rem',
    justifyContent: 'center',
    padding: '30px',
    width: '6.5rem',
  },
  errorIcon: {
    height: '3.5rem',
    objectFit: 'contain',
    width: '3.5rem',
  },
  folderLink: {
    color: GREEN_BUTTON,
  },
  header: {
    color: DARK_TEXT_COLOR,
    fontSize: '0.875rem',
    fontWeight: '400',
    lineHeight: '140%',
  },
};

export const ProcessingView = ({
  documentId,
  documentLabel = 'document',
  errorMessage,
  ingestionError,
  ingestionStatus,
  onComplete,
  rollForwardFolder,
  setIngestionError,
  setIngestionStatus,
}) => {
  const defaultErrorMessage =
    'There was an error processing your upload. Please contact support.';

  return (
    <Stack direction="column" flex={1} justifyContent="space-between">
      {ingestionStatus !== INGESTION_STATUSES.failed && (
        <>
          <Typography pb={2} style={styles.header}>
            This process can take up to twenty minutes. We will email you when
            the process is complete. Closing this window will not disrupt the
            process.
          </Typography>
          <ProcessingContainer
            documentId={documentId}
            onComplete={onComplete}
            setIngestionError={setIngestionError}
            setIngestionStatus={setIngestionStatus}
          />
          {rollForwardFolder?.name?.length > 0 && (
            <>
              <Typography align="center" pb={2} pt={2} style={styles.header}>
                {documentLabel} was placed in the{' '}
                <strong>
                  {rollForwardFolder?.year} {rollForwardFolder?.name}
                </strong>{' '}
                folder
              </Typography>
              <Link
                align="center"
                href={`/folders/${rollForwardFolder?.id}/documents`}
                style={styles.folderLink}
              >
                <strong>Go to Folder</strong>
              </Link>
            </>
          )}
        </>
      )}
      {ingestionStatus === INGESTION_STATUSES.failed && (
        <Stack
          alignItems="center"
          height="100%"
          justifyContent="space-between"
          spacing="0.5rem"
          width="100%"
        >
          <Box sx={styles.errorContainer}>
            <img
              alt="Warning Alert"
              src={WarningAlertIcon}
              style={styles.errorIcon}
            />
          </Box>
          <Typography
            style={{...styles.header, paddingTop: '2rem'}}
            sx={{whiteSpace: 'pre-line'}}
          >
            {errorMessage ||
              ingestionError?.errorMessage ||
              defaultErrorMessage}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

ProcessingView.propTypes = {
  documentId: PropTypes.string,
  documentLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  ingestionError: PropTypes.object,
  ingestionStatus: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  rollForwardFolder: PropTypes.object,
  setIngestionError: PropTypes.func.isRequired,
  setIngestionStatus: PropTypes.func.isRequired,
};
